import { render, staticRenderFns } from "./ContactRegionalEnergy.vue?vue&type=template&id=e0cc525c"
import script from "./ContactRegionalEnergy.vue?vue&type=script&lang=js"
export * from "./ContactRegionalEnergy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports